/**
 * AccordionRow.jsx
 * Created by michaelbray on 3/8/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../icons/Icons';

const propTypes = {
    showRow: PropTypes.bool,
    rowIndex: PropTypes.number,
    label: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string
    }),
    clickedRow: PropTypes.func
};

export default class AccordionRow extends React.Component {
    constructor(props) {
        super(props);

        this.rowClicked = this.rowClicked.bind(this);
    }

    rowClicked() {
        this.props.clickedRow(this.props.rowIndex);
    }

    render() {
        let icon = <Icons.IconChevronDown className="rec-icon-chevron-down" />;
        if (this.props.showRow) {
            icon = <Icons.IconChevronUp className="rec-icon-chevron-down" />;
        }

        return (
            <div className="rec-accordion-row">
                <button
                    className="rec-accordion-row-button"
                    onClick={this.rowClicked}>
                    {icon}
                    <span>{this.props.label.title}</span>
                </button>
                <div className="rec-accordion-label">
                    <div className="rec-accordion-row-subtitle">
                        {this.props.label.subtitle}
                    </div>
                </div>
            </div>
        );
    }
}

AccordionRow.propTypes = propTypes;
